import React from "react";

export function sliceObjects(
    array: any[],
    pageSize: number,
    currentPage: number,
) {
    return array.slice(currentPage * pageSize, (currentPage + 1) * pageSize);
}


export const removeDuplicateFromArray = (array: any[]) => {
    return array.filter((c, index) => {
        return array.indexOf(c) === index;
    });
};

export const getObjValueInDeep = (obj: { [key: string]: any }, deepProperties: string) => {
    try {
        const properties = deepProperties.split('.');

        properties.forEach((property) => {
            if (
                obj[property] ||
                !!obj[property] ||
                typeof obj[property] === 'boolean' ||
                typeof obj[property] === 'number' || Array.isArray(obj[property])
            ) {
                obj = obj[property];
            }

            if (obj[property] === null) {
                obj[property] = null;
                obj = obj[property];
            }
        });
        if (React.isValidElement(obj)) {
            return obj;
        }

        return typeof obj === 'object' && !Array.isArray(obj) ? '' : ((obj ?? '') as any);
    } catch (e) {
        return '';
    }
};

export function iterator(f: number, u: number) {
    const arr: number[] = [];
    let i = f;
    while (i <= u) arr.push(i++);
    return arr;
}

export function isJsonString(str: string) {
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
}

export const getJsonString = (str: string) => {
    if (isJsonString(str)) {
        return JSON.parse(str);
    }

    return null
}

export function filterEmptyProperties<T>(obj: T, currentDepth: number = 0): T {
    if (Array.isArray(obj)) {
        return obj
            .map(item => filterEmptyProperties(item, currentDepth + 1))
            .filter(item => item !== undefined && item !== null) as unknown as T;
    }

    if (typeof obj === 'object' && obj !== null) {
        const newObject: any = {};

        for (const property in obj) {
            const propertyValue = obj[property];

            if (typeof propertyValue !== 'object' || propertyValue === null) {
                if (propertyValue !== undefined && propertyValue !== null) {
                    newObject[property] = propertyValue;
                }
            } else {
                if (currentDepth < 100) {
                    const filteredPropertyValue = filterEmptyProperties(propertyValue, currentDepth + 1);

                    if (filteredPropertyValue && Object.keys(filteredPropertyValue).length > 0 || Array.isArray(propertyValue)) {
                        newObject[property] = filteredPropertyValue;
                    }
                }
            }
        }

        return Object.keys(newObject).length > 0 ? newObject : undefined;
    }

    return obj;
}

export function extractUniqueItems<T = any>(
    rows: T[],
    key: keyof T
): string[] {
    const uniqueItems = new Set<string>();

    for (const row of rows) {
        const value = row[key];
        if (value) {
            uniqueItems.add(value as string);
        }
    }

    return Array.from(uniqueItems);
}


export function flattenObject(obj: any, parentKey: string = '', sep: string = '.'): any {
    const result: any = {};

    for (const key in obj) {
        const newKey = parentKey ? `${parentKey}${sep}${key}` : key;
        if (obj[key]) {
            if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
                Object.assign(result, flattenObject(obj[key], newKey, sep));
            } else {
                result[newKey] = obj[key] === null ? '' : obj[key];
            }
        }else{
            result[newKey] = "";
        }
    }

    return result;
}

export const mergeObjects = (obj1: any, obj2: any) => {
    return Object.keys({ ...obj1, ...obj2 }).reduce((acc: any, key: any) => {
        if (obj1[key] && obj2[key] && typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
            acc[key] = mergeObjects(obj1[key], obj2[key]);
        } else {
            acc[key] = obj2[key] !== undefined ? obj2[key] : obj1[key];
        }
        return acc;
    }, {});
};
